<script>
export default {
	name: 'sky-svg',
	// <div /> instead of <svg /> because svg's don't have outerHTML
	template: '<div></div>',
	props: {
		name: {
			type: String,
			required: true,
		},
	},
	methods: {
		mountSvg(svg) {
			this.$el.outerHTML = svg;
			this.$destroy();
		},
	},
	mounted() {
		/**
		 * Require all svgs inside svgs folder to load into bundle.js,
		 * then get specific svg from name.
		 */
		const allSvgs = require.context('svgs/', true, /\.svg$/);
		const rootElementClasses = this.$el.className;

		let svgClass = `svg-${this.name}`;
		if (rootElementClasses.length) {
			svgClass = `${svgClass} ${rootElementClasses}`;
		}
		const svg =
			allSvgs(`./${this.name}.svg`)
			.replace('<svg', `<svg class="${svgClass}"`);

		this.mountSvg(svg);
	},
};
</script>



// WEBPACK FOOTER //
// sky-svg.vue?6d4b02f4